import { BiSolidCalendarEvent } from "react-icons/bi";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import c1 from "../assets/images/club-list1.svg";
import c2 from "../assets/images/c2.svg";
import c3 from "../assets/images/c3.svg";
import { useAuth } from "../../src/context/AuthContext";
import { useNavigate } from "react-router-dom";


const clubs = [
  {
    name: "Travelers Haven",
    members: "12.4k",
    posts: "860",
    polls: "4",
    events: "3",
    image: c1,
  },
  {
    name: "Rock Music",
    members: "560",
    posts: "32",
    polls: "4",
    events: "1",
    image: c2,
  },
  {
    name: "Pizza Lovers",
    members: "22.8k",
    posts: "5.6k",
    polls: "44",
    events: "0",
    image: c3,
  },
];

const MyClubsComponent = ({ title = "My Clubs" }) => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="suggested-section my-club">
     <h3 className="mb-15">{title}</h3>
      <div className="suggested-club-card">
            <div className="suggested-club-card-top">
                {clubs.map((club, index) => (
                    <div key={index} className="suggested-club-item">
                            <div className="suggested-club-item-inner">
                                <div className="club-image">
                                    <Image src={club.image} alt={club.name}/>
                                </div>
                                
                                <div className="club-content">
                                    <h5>{club.name}</h5>
                                    <p>{club.members} members</p>
                                    <p>
                                        <FaSquarePollHorizontal />
                                        {club.posts} Posts & {club.polls} Polls
                                    </p>
                                    {club.events > 0 && (
                                        <p>
                                            <BiSolidCalendarEvent /> {club.events} Active event{club.events > 1 ? "s" : ""}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <Button variant="outline-primary" className="br-10 join" disabled={!isAuthenticated}>
                                Invite
                            </Button>
                    </div>
                    
                ))}

            </div>

            <div className="suggested-club-card-button">
                <Button variant="link" onClick={() => navigate("/my-clubs")}>View All</Button>
            </div>
      </div>
    </div>
  );
};

export default MyClubsComponent;
